<template>
    <div class="inline-block">
        <div @click.prevent="isOpen = ! isOpen">
            <slot></slot>
        </div>
        <div v-show="isOpen" class="Dropdown__links absolute mt-1 py-2 max-w-6xl text-base font-sans bg-white border border-gray-200 rounded shadow-md">
            <slot name="links"></slot>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isOpen: false
        }
    },

    watch: {
        isOpen(isOpen) {
            if (isOpen) {
                document.addEventListener('click', this.closeIfClickedOutside);
            }
        }
    },

    methods: {
        closeIfClickedOutside(event) {
            if (! this.$el.contains(event.target)) {
                this.isOpen = false;
                document.removeEventListener('click', this.closeIfClickedOutside);
            }
        }
    }
}
</script>

<style lang="scss">
    .Dropdown__links a {
        display: block;
        padding: .2rem 1rem;

        &:hover {
            background-color: var(--darken-lighter);
        }
    }
</style>
